import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect } from 'react';

export default function bannerbox(props) {
  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick_custom = (e, item) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '홍보 배너',
        clickType: 'NC',
        value1: item.m_img_attr, // 모바일이므로 m_img_attr 사용
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  try {
    // 무조건 1개 데이터라고 가정
    const banner = props.data?.contents?.[0];

    if (!banner) {
      return <></>;
    }


    return (
        <div className="contentsBlock_w">
          <div className="adBanner_w">
            {/*<iframe title='배너광고' display='block' src={banner.m_img_url} width='320px' height='50px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />*/}


            <Link
                href={banner.link_url}
                target={banner.link_new_yn === 'Y' ? '_blank' : ''}
                onClick={(e) => handleClick_custom(e, banner)}
                style={{ cursor: 'pointer' }} // This will change the cursor to a hand when hovering over the link
            >
            <img
                src={banner.m_img_url}
                alt={banner.m_img_attr || '배너광고영역'}


            />
            </Link>

          </div>
        </div>


    );
  } catch (error) {
    console.error('bannerbox render error:', error);
    return <></>;
  }
}
